import React, { useState, useEffect } from "react";
import { Form, Grid, Button } from "tabler-react";

const ModalDestino = ({ estado, municipio, colonia, calle, numero, cp, setEstado, setMunicipio, setColonia, setCalle, setNumero, setCP, cerrarModal }) => {
  const [e, setE] = useState(estado || "");
  const [m, setM] = useState(municipio || "");
  const [col, setCol] = useState(colonia || "");
  const [cal, setCal] = useState(calle || "");
  const [num, setNum] = useState(numero || "");
  const [c, setC] = useState(cp || "");

  const guardar = () => {
    setEstado(e);
    setMunicipio(m);
    setColonia(col);
    setCalle(cal);
    setNumero(num);
    setCP(c);
    if (cerrarModal) cerrarModal();
  };

  const completo = e && m && col && cal && num && c;

  return (
    <div>
      <Grid.Row>
        <Grid.Col md={6}>
          <Form.Group label={<div>Estado<label className="font-weight-bold text-danger">*</label></div>}>
            <Form.Input value={e} onChange={(ev) => setE(ev.target.value.toUpperCase())} style={{ textTransform: "uppercase" }} placeholder="Ej: JALISCO" />
          </Form.Group>
        </Grid.Col>
        <Grid.Col md={6}>
          <Form.Group label={<div>Municipio<label className="font-weight-bold text-danger">*</label></div>}>
            <Form.Input value={m} onChange={(ev) => setM(ev.target.value.toUpperCase())} style={{ textTransform: "uppercase" }} placeholder="Ej: GUADALAJARA" />
          </Form.Group>
        </Grid.Col>
        <Grid.Col md={6}>
          <Form.Group label={<div>Colonia<label className="font-weight-bold text-danger">*</label></div>}>
            <Form.Input value={col} onChange={(ev) => setCol(ev.target.value.toUpperCase())} style={{ textTransform: "uppercase" }} placeholder="Ej: CENTRO" />
          </Form.Group>
        </Grid.Col>
        <Grid.Col md={6}>
          <Form.Group label={<div>Calle<label className="font-weight-bold text-danger">*</label></div>}>
            <Form.Input value={cal} onChange={(ev) => setCal(ev.target.value.toUpperCase())} style={{ textTransform: "uppercase" }} placeholder="Ej: AV. JUAREZ" />
          </Form.Group>
        </Grid.Col>
        <Grid.Col md={6}>
          <Form.Group label={<div>Número<label className="font-weight-bold text-danger">*</label></div>}>
            <Form.Input value={num} onChange={(ev) => setNum(ev.target.value.replace(/\D/g, ''))} placeholder="Ej: 123" />
          </Form.Group>
        </Grid.Col>
        <Grid.Col md={6}>
          <Form.Group label={<div>Código Postal<label className="font-weight-bold text-danger">*</label></div>}>
            <Form.Input
              value={c}
              onChange={(ev) => setC(ev.target.value.replace(/\D/g, '').slice(0, 5))}
              onBlur={(ev) => { const v = ev.target.value.replace(/\D/g, ''); if (v.length > 0 && v.length < 5) setC(v.padStart(5, '0')); }}
              maxLength="5"
              placeholder="Ej: 44100"
            />
          </Form.Group>
        </Grid.Col>
      </Grid.Row>
      <div className="text-center mt-3 mb-3">
        <Button color="primary" onClick={guardar} disabled={!completo}>Aceptar</Button>
      </div>
    </div>
  );
};

export default ModalDestino;
